(function () {
  var triggered = false;
  function revealPage() {
    if (triggered) return;
    triggered = true;
    document.body.classList.add('has-scrolled');
  }
  window.addEventListener('scroll', revealPage, { once: true });
  window.addEventListener('touchmove', revealPage, { once: true });
})();
